import React, { FC } from 'react';

import Title from 'components/curo-components/common/Title';
import QuestionIcon from 'product_modules/components/QuestionIcon';
import { CheckMarkIcon } from 'static/images';
import styled from 'types/AppTheme';

const StyledWrapper = styled.label`
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  border: 1px solid #e7e9ec;
  border-radius: 12px;
  cursor: pointer;
  padding: 24px;

  & > h5 {
    margin-bottom: 24px;
    display: flex;
    gap: 8px;
    align-items: center;

    & > p {
      width: 24px !important;
      height: 24px !important;
      font-size: 14px;
    }
  }

  & > div.icon {
    content: '';
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    top: 24px;
    right: 24px;
    border: 2px solid ${({ theme }) => theme.colors.brandColor};
    border-radius: 50%;
  }

  &:has(input:checked) {
    outline: 3px solid ${({ theme }) => theme.colors.brandColor};
    border: 1px solid transparent;
  }

  &:has(input:checked) > div.icon {
    background-color: ${({ theme }) => theme.colors.brandColor};
  }

  & > input {
    display: none;
  }
`;

interface ICheckboxWrapperProps {
  checked: boolean;
  value: string;
  onChange: (value: string) => void;
  title?: string;
  questionIconTooltip?: React.ReactNode;
}

const CheckboxWrapper: FC<ICheckboxWrapperProps> = ({
  children,
  onChange,
  value,
  checked,
  title,
  questionIconTooltip,
}) => {
  return (
    <StyledWrapper>
      {title && (
        <Title type="h5">
          {title}
          {questionIconTooltip && <QuestionIcon tooltip={questionIconTooltip} />}
        </Title>
      )}
      <div className="icon">
        <CheckMarkIcon />
      </div>
      <input type="checkbox" onChange={() => onChange(value)} value={value} checked={checked} />
      {children}
    </StyledWrapper>
  );
};

export default CheckboxWrapper;
